import {
  TotalAshaTable,
  AshaDetailscolumns,
  AshaActiveInactiveColumns,
} from "../Constant/TableConstants";
import bellIcon from "../../Assets/bell_icon.png";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
export const getColumns = (isAdmin, tableName, isActive, t) => {
  let columns = [];

  switch (tableName) {
    case "TotalAshaTable":
      columns = TotalAshaTable();
      if (isActive === "Inactive") {
        columns.push({
          field: "inactiveSince",
          header: t("lastActive"),
          filter: true,
          frozen: true,
          alignFrozen: "right",
          showFilterMenu: false,
        });
      }
      break;

    case "AshaDetails":
      columns = AshaDetailscolumns();
      break;
    case "AshaActiveInactive":
      columns = AshaActiveInactiveColumns();
      if (isActive === "Inactive") {
        columns.push({
          field: "inactiveSince",
          header: t("lastActive"),
          filter: true,
          frozen: true,
          alignFrozen: "right",
          showFilterMenu: false,
        });
      }
      break;

    // Add more cases for additional tables

    default:
      break;
  }

  if (isAdmin === "Admin" || isAdmin === "Support Admin") {
    columns.unshift({
      field: "select",
      header: t("Select All"),
      frozen: true,
      filter: false,
    });
  }

  return columns;
};

export const headerStyle = {
  borderRight: "3px solid #d9d9d9",
};

export const bodyStyle = {
  borderLeft: "3px solid #d9d9d9",
};

export const reminderBodyTemplate = (props) => {
  return (
    <div className="flex align-items-center">
      <img src={bellIcon} alt="reminder-icon" />
      <div className="pl-2 text-center">
        {props.reminderCount || props.remindersCount || props.RemainderCount}
      </div>
    </div>
  );
};

export const ashaDetailFilterTemplate = (options, t) => {
  return (
    <div className="p-input-icon-right">
      <i className="pi pi-search custom-search-icon" />
      <InputText
        type="text"
        value={options.value}
        onChange={(e) => options.filterApplyCallback(e.target.value)}
        placeholder={t("Search")}
        className="p-column-filter"
      />
    </div>
  );
};

export const buildSelectedIds = (items) => {
  let idsList = [];
  items.length > 0 &&
    items.forEach((el) => {
      idsList.push(el.ashaId);
    });
  return idsList;
};

export const createDropdownFilterTemplate = (data, t) => (options) => {
  return (
    <Dropdown
      value={options.value}
      options={Array.from(new Set(data.map(String))).map((value) => ({
        label: String(value),
        value,
      }))}
      onChange={(e) => options.filterApplyCallback(e.value)}
      placeholder={t("Search")}
      showClear
    />
  );
};
